import { appendGalleryCaptions } from "./modules/append-gallery-captions";
import { resetBookingPersonsInput } from "./modules/reset-booking-persons-input";
import { toggleContactRibbon } from "./modules/toggle-contact-ribbon";

function initializeScripts() {
  appendGalleryCaptions();
  resetBookingPersonsInput();
  toggleContactRibbon();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeScripts, { once: true });
} else {
  initializeScripts();
}
